module.exports = __webpack_public_path__ + "static/media/sub-hero.e5a18b95.svg";